import { useState, useContext } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const useContactForm = () => {
  const { baseUrl, baseURL2, basicAuth } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);

  const submitContactForm = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        userid: "",
        step: "1",
        step1: {
          fullName: formData.fullName,
          phoneNumber: formData.phoneNumber,
          workEmail: formData.workEmail,
          message: formData.message,
        },
      };

      const response = await axios.post(
        `${baseUrl}/User/v1.0/updateUserDetails`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: basicAuth,
          },
        },
      );

      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const submitForm = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        fullname: formData.fullName,
        email: formData.workEmail,
        website: formData.website || "",
        contact: formData.phoneNumber,
      };

      const response = await axios.post(
        `${baseURL2}/Auth/InsertLeads`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.data?.status === "0") {
        return {
          success: true,
          message:
            response.data?.result?.[0]?.message ||
            "Form submitted successfully",
        };
      } else {
        return {
          success: false,
          message: "Submission failed. Please try again.",
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  const submitEnquiryDetails = async (formData) => {
    setLoading(true);

    try {
      const payload = {
        full_name: formData.fullName || "",
        phone_number: formData.phoneNumber || "",
        email: formData.email || "",
        enquiry_type: formData.enquiryType || "",
        description: formData.description || "",
      };

      const response = await axios.post(
        `${baseUrl}/User/v1.0/InsertEnquiryDetails`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: basicAuth,
          },
        },
      );

      return {
        success: true,
        data: response.data,
        message:
          response.data?.responseMessage || "Enquiry submitted successfully",
      };
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.responseMessage ||
          error?.response?.data?.message ||
          "Something went wrong",
      };
    } finally {
      setLoading(false);
    }
  };

  return { submitContactForm, submitForm, submitEnquiryDetails, loading };
};

export default useContactForm;
